import styles from "./perfil-miriam.module.css";
import PerfilCover from "../../../components/EquipeComponents/PerfilCover/perfil-cover";
import miriamPerfil from "../../../images/_finais/Foto-Miriam_compress.webp";

const PerfilMiriam = () => {
  const onClickLink = (link: string) => {
    return window.open(link, "_blank");
  };

  return (
    <main className={styles.perfil_main}>
      <PerfilCover
        title=" Miriam A. Zago Marcolino"
        text="Possui experiência na área de evidências de mundo real (RWE) e 
        avaliação de tecnologias em saúde. Com sólida formação na área, durante 
        o doutorado em Epidemiologia desenvolveu tese sobre dados de mundo real 
        (RWD) no SUS. Atuou no desenvolvimento do painel de indicadores da 
        assistência cardiovascular do SUS - iCardio, como responsável pela 
        análise de dados."
        image={miriamPerfil}
        lattes={"https://lattes.cnpq.br/0445915839669429"}
        linkedin={"https://www.linkedin.com/in/miriam-a-zago-marcolino/"}
      />
      <p className={styles.descriptionMobile}>
        Possui experiência na área de evidências de mundo real (RWE) e avaliação
        de tecnologias em saúde. Com sólida formação na área, durante o
        doutorado em Epidemiologia desenvolveu tese sobre dados de mundo real
        (RWD) no SUS. Atuou no desenvolvimento do painel de indicadores da
        assistência cardiovascular do SUS - iCardio, como responsável pela
        análise de dados.
      </p>
      <section className={styles.publicacoes}>
        <h3 className={styles.publicacoesTitle}>
          Publicações em Real World Evidence nos últimos anos:
        </h3>
        <ul className={styles.publicacoesList}>
          <li className={styles.publicacoesItem}>
            • Icardio: painel de indicadores em atenção cardiovascular no SUS:
            e-book sobre o desenvolvimento e orientações de uso. Instituto de
            Avaliação de Tecnologia em Saúde – Porto Alegre: UFRGS/HCPA IATS,
            2024. 50p. E-Book: 978-65-00-97337-2.
            <button
              className={styles.btnVer}
              onClick={() =>
                onClickLink("https://www.iats.com.br/projects/icardio/")
              }
            >
              Ver
            </button>
          </li>
          <li className={styles.publicacoesItem}>
            • Cost of hemophilia A in Brazil: a microcosting study. Health
            Economics Review, v. 14, n. 1, p. 62, 2024.
            <button
              className={styles.btnVer}
              onClick={() =>
                onClickLink(
                  "https://healtheconomicsreview.biomedcentral.com/articles/10.1186/s13561-024-00539-x#:~:text=The%20median%20cost%20per%20patient,%E2%89%A519%20yrs%20R%24718%2C969)."
                )
              }
            >
              Ver
            </button>
          </li>
          <li className={styles.publicacoesItem}>
            • Cardiac Implantable Electronic Device Centers’ Landscape in the
            Brazilian Public Healthcare: A 12-Year Real World Data Analysis.
            Value in Health, v. 26, n. 6, p. S366, 2023.
            <button
              className={styles.btnVer}
              onClick={() =>
                onClickLink(
                  "https://www.ispor.org/docs/default-source/intl2023/poster-ispor---id-127740-pdf.pdf?sfvrsn=bf7c9b45_0"
                )
              }
            >
              Ver
            </button>
          </li>
          <li className={styles.publicacoesItem}>
            • Comparison of COVID-19 hospitalization costs across care pathways:
            a patient-level time-driven activity-based costing analysis in a
            Brazilian hospital. BMC Health Services Research, v. 23, n. 1, p.
            198, 2023.
            <button
              className={styles.btnVer}
              onClick={() =>
                onClickLink(
                  "https://bmchealthservres.biomedcentral.com/articles/10.1186/s12913-023-09049-8"
                )
              }
            >
              Ver
            </button>
          </li>
          <li className={styles.publicacoesItem}>
            • Access Trends to Cardiac Implantable Electronic Devices in the
            Brazilian Public Healthcare System: A Twelve-Year Real World Data
            Analysis. Value in Health, v. 26, n. 12, p. S234, 2023.
            <button
              className={styles.btnVer}
              onClick={() =>
                onClickLink(
                  "https://www.ispor.org/docs/default-source/euro2023/isporeurope23marcolinoeph166poster133913-pdf.pdf?sfvrsn=12ec4245_0"
                )
              }
            >
              Ver
            </button>
          </li>
          <li className={styles.publicacoesItem}>
            • Moving the Brazilian ischaemic stroke pathway to a value-based
            care: introduction of a risk-adjusted cost estimate model for stroke
            treatment. Health Policy and Planning, v. 37, n. 9, p. 1098-1106,
            2022.
            <button
              className={styles.btnVer}
              onClick={() =>
                onClickLink(
                  "https://academic.oup.com/heapol/article/37/9/1098/6648418?login=false"
                )
              }
            >
              Ver
            </button>
          </li>
        </ul>
      </section>
    </main>
  );
};

export default PerfilMiriam;
